import Axios from 'axios';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import userImg from 'src/images/user.png';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { login } from 'src/services';
import { validEmailRegex } from 'src/utils/validaciones';
import { withToastManager } from 'react-toast-notifications';
import useCustomToast from 'src/hooks/useCustomToast';
import ModalComponent from 'src/components/Modal';
import { Dropdown } from 'primereact/dropdown';
import { urlGetUserAgencias, urlGetProductosCanal, urlAgenciasUsuario } from 'src/services/urls';

const Login = () => {
  const { empAplica, empBroker, canal } = useParams<{ empAplica: string, empBroker: string, canal: string }>();
  const [agencia, setagencia] = useState(null);
  const [agencias, setagencias] = useState(null);
  const [usuarios, setUsuarios] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [productosCanal, setProductosCanal] = useState(null);
  const [productoCanal, setProductoCanal] = useState(null);
  const [dataLogin, setdataLogin] = useState({});

  const [showAgencias, setshowAgencias] = useState(false);
  const [urlRedireccion, seturlRedireccion] = useState(null);
  const [loadingAgencias, setloadingAgencias] = useState(false);

  const { addWarningToast } = useCustomToast();
  const [loading, setLoading] = useState(false);
  const { formState: { errors, }, handleSubmit, setError, control } = useForm({ mode: 'onChange' });

  const inicioSesion = async (data, op) => {
    setLoading(true);
    let body = {
    };
    if (op === 1) {
      body = {
        ...data,
        empAplica,
        empBroker,
        canal,
      };
    }
    else {
      body = {
        ...dataLogin,
        usuarioSeleccionado: data,
        empAplica,
        empBroker,
        canal,
        canalSeleccionado: productoCanal
      };
    }
    console.log({ body });
    // debugger

    let { data: data2, status, ...res } = await login(body);

    if (data2.transaccion) {
      data = data2.data;
      if (data.agencias) {
        setagencias(data.agencias);
        seturlRedireccion(data.url);
        setshowAgencias(true);
        setLoading(false);
      } else {
        window.location.href = `/${data.url}${usuario ? `?usuario=${usuario}` : ''}`;
      }
    } else {
      setLoading(false);
      addWarningToast(data2.mensaje || data2.errorDescripcion);
      setError('usuario', {
        type: 'manual',
        message: data2?.mensaje || data2.errorDescripcion || 'Algo a salido mal.',
      });
    }
  };

  const getProductosCanal = async (data) => {
    setloadingAgencias(true);
    const body = {
      ...data,
      empAplica,
      empBroker,
      canal,
    };
    try {
      const { data: res } = await Axios.post(urlGetProductosCanal(), body);
      console.log("res", res)
      if (res.transaccion) {
        if (res.canales.length === 0) {
          inicioSesion(data, 1);
          return;
        }
        setdataLogin(data);
        setProductosCanal(res.canales);
        setshowAgencias(true);
      } else {
        addWarningToast(res?.mensaje || res?.errorDescripcion || 'Error iniciando sesión');
      }
    } catch (error) {
      console.log("error", error)
    }
    setloadingAgencias(false);
  }
  const getAgenciasUsuario = async (data) => {
    console.log("getAgenciasUsuario", data)
    setloadingAgencias(true);
    const body = {
      ...dataLogin,
      empAplica,
      empBroker,
      canal,
      canalSeleccionado: data
    };
    try {
      const { data: res } = await Axios.post(urlAgenciasUsuario(), body);
      console.log("res", res)
      if (res.transaccion) {
        setagencias(res?.data?.agencias);
      }
    } catch (error) {
      console.log("error", error)
    }
    setloadingAgencias(false);
  }


  const getUsuarios = async (id) => {
    const { data } = await Axios.post(urlGetUserAgencias(), {
      id, ...dataLogin,
      empAplica,
      empBroker,
      canal,
      canalSeleccionado: productoCanal
    });
    if (data.transaccion) {
      setUsuarios(data.usuarios);
    } else {
      addWarningToast(data.mensaje || data.errorDescripcion);
    }
    setloadingAgencias(false);
  };

  const continuar = () => {
    inicioSesion(usuario, 0);
    // if (usuario) {
    //   window.location.href = `${urlRedireccion}?usuario=${usuario}`;
    // }
  }
  console.log({ agencias, usuarios, productosCanal })

  return (
    <LoadingWrapper loading={loading} secundario="Verificando información del usuario">
      <div className="container-fluid h-100">
        <div className="row justify-content-center h-100">
          <div className="col-md-12 col-lg-10 col-xl-8  align-self-center ">
            <div className="card p-4">
              <div className="row">
                <div className="col-md-6 text-center ">
                  <img
                    className="img-fluid"
                    src={userImg}
                    alt="IMG USUARIO"
                    style={{ height: '150px' }}
                  />
                  <h3>Bienvenido</h3>
                  <p>Para continuar ingrese su email y contraseña</p>
                </div>

                <div className="col-md-6 align-self-center">
                  <form noValidate onSubmit={handleSubmit(getProductosCanal)}>
                    <div className="form-group p-3 ">
                      <Controller
                        name="usuario"
                        defaultValue=""
                        control={control}
                        rules={{
                          required: 'Este campo es obligatorio',
                          pattern: {
                            value: validEmailRegex,
                            message: 'Ingrese un correo válido',
                          },
                        }}
                        render={({ field: { onChange, value } }) => (
                          <InputText
                            id="emailId"
                            value={value}
                            type="email"
                            // required={input.required}
                            // maxLength={input.length}
                            // type={type}
                            // inputMode={(type === 'tel' ? 'numeric' : 'text')}
                            // contentEditable={input.editable}
                            // disabled={processDisabled(input, loading)}
                            onChange={({ currentTarget, ...res }) => {
                              onChange(currentTarget.value);
                            }}
                            placeholder="Email"
                          />)
                        }
                      />
                    </div>

                    <div className="form-group p-3">
                      <Controller
                        control={control}
                        name="pass"
                        defaultValue=""
                        rules={{
                          required: 'Este campo es obligatorio',
                        }}
                        render={({ field: { onChange, value } }) => (
                          <InputText
                            id="pass"
                            value={value}
                            // label="ContraseÃ±a"
                            // variant="outlined"
                            // fullWidth
                            // required
                            type="password"
                            onChange={onChange}
                            // error={errors.pass !== undefined}
                            // helperText={errors.pass && errors.pass.message}
                            placeholder="Contraseña"
                          />)
                        }
                      />
                    </div>
                    <div className='p-3'>
                      <Button label="Iniciar Sesión" type="submit" className='w-100' />
                      {/* icon="pi pi-send" iconPos="top"  */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        show={showAgencias}
        titulo="Seleccione los siguientes datos"
        onClose={() => setshowAgencias(false)}
      >
        <>
          <div className="row">
            <div className="col-md-12">
              <h6>Seleccione el canal comercial</h6>
              <span className="p-float-label">
                <Dropdown
                  options={productosCanal}
                  disabled={!productosCanal}
                  // label={'Seleccione el Canal comercial'}
                  // editable={input?.editable}
                  // disabled={input?.disabled}
                  // required={rules.hasOwnProperty('required')}
                  dataKey="val"
                  value={productoCanal}
                  optionLabel="nombre"
                  optionValue="codCore"
                  filterBy="nombre"
                  // filter={options.length > 10}
                  onChange={(evt) => {
                    console.log('SELECT2', evt?.value);
                    setProductoCanal(evt?.value);
                    setagencias(null);
                    setagencia(null);
                    setUsuarios(null);
                    setUsuario(null);
                    setloadingAgencias(true);
                    getAgenciasUsuario(evt?.value);
                  }}
                />
                <label />
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <h6>Seleccione la Agencia</h6>
              <span className="p-float-label">
                <Dropdown
                  options={agencias}
                  disabled={!agencias}

                  // label={'Seleccione la Agencia'}
                  // label={input?.campo}
                  // editable={input?.editable}
                  // disabled={input?.disabled}
                  // required={rules.hasOwnProperty('required')}
                  dataKey="val"
                  value={agencia}
                  optionLabel="nombre"
                  optionValue="codCore"
                  filterBy="nombre"
                  // filter={options.length > 10}
                  onChange={(evt) => {
                    console.log('SELECT2', evt?.value);
                    setagencia(evt?.value);
                    setUsuarios(null);
                    setUsuario(null);
                    setloadingAgencias(true);
                    getUsuarios(evt?.value);
                  }}
                />
                <label />
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              {loadingAgencias && (
                <div
                  className=" col-12 text-center position-absolute p-tooltip-arrow "
                  style={{ zIndex: 1, top: '1rem', width: '100%' }}
                >
                  <i className="pi pi-spin pi-spinner" />
                </div>
              )}
              <h6>Seleccione el usuario</h6>
              <span className="p-float-label">
                <Dropdown
                  options={usuarios}
                  // label={input?.campo}
                  // editable={input?.editable}
                  disabled={!usuarios}
                  // required={rules.hasOwnProperty('required')}
                  dataKey="val"
                  value={usuario}
                  optionLabel="nombre"
                  optionValue="codCore"
                  filterBy="nombre"
                  // filter={options.length > 10}
                  onChange={(evt) => {
                    setUsuario(evt?.value);
                  }}
                />
                <label />
              </span>
            </div>
          </div>
          <div className="pt-3 m-auto text-center">
            <Button label="Continuar" icon="pi pi-send" iconPos="right" onClick={() => continuar()} />
          </div>
        </>
      </ModalComponent>
    </LoadingWrapper>
  );
};

export default withToastManager(Login);